import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import Iconify from '../../../components/Iconify';

// The outcome cards of the follow-up step (Book Appointment / Spoke - Not Booked /
// No Answer). Shared by FollowUp and the call flow's unknown-caller screen, so
// both look the same.
export default function OutcomeCardGrid({ options, onSelect, columns = 3, disabled = false }) {
    return (
        <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: { xs: 1, sm: 1.5 }, width: '100%', maxWidth: 560 }}>
            {options.map((opt) => (
                <Box
                    key={opt.key}
                    data-testid={`outcome-card-${opt.key}`}
                    role="button"
                    tabIndex={disabled ? -1 : 0}
                    aria-disabled={disabled}
                    onClick={() => { if (!disabled) onSelect(opt.key); }}
                    onKeyDown={(e) => { if (!disabled && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); onSelect(opt.key); } }}
                    sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: { xs: 0.5, sm: 1 },
                        px: { xs: 1, sm: 2 }, py: { xs: 1.5, sm: 2.5 }, borderRadius: '12px', minHeight: { xs: 90, sm: 140 },
                        cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.6 : 1, transition: 'all 200ms ease', background: opt.bg,
                        border: '1px solid transparent', justifyContent: 'center',
                        '&:hover': disabled ? {} : { borderColor: opt.color, boxShadow: `0 0 0 1px ${opt.color}22` },
                        '&:active': disabled ? {} : { transform: 'scale(0.97)' },
                    }}
                >
                    <Box sx={{ width: { xs: 36, sm: 48 }, height: { xs: 36, sm: 48 }, borderRadius: { xs: '10px', sm: '12px' }, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                        <Iconify icon={opt.icon} width={{ xs: 18, sm: 24 }} sx={{ color: opt.color }} />
                    </Box>
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600, color: '#212B36', whiteSpace: 'nowrap' }}>{opt.label}</Typography>
                    <Typography sx={{ fontSize: { xs: '10px', sm: '11px' }, color: '#919EAB', fontWeight: 400, textAlign: 'center', lineHeight: 1.3, display: { xs: 'none', sm: 'block' } }}>{opt.sub}</Typography>
                </Box>
            ))}
        </Box>
    );
}

OutcomeCardGrid.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        sub: PropTypes.string,
        color: PropTypes.string.isRequired,
        bg: PropTypes.string,
    })).isRequired,
    onSelect: PropTypes.func.isRequired,
    columns: PropTypes.number,
    disabled: PropTypes.bool,
};
